"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _invariant = _interopRequireDefault(require("invariant"));

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _mountPoint = require("./mountPoint");

var _actions = require("../actions");

/**
 * Helper function for providing props to redux-input controlled components
 * @param inputConfig
 * @param state - redux-inputs form state
 * @param dispatcher
 */
var _default = function _default(inputConfig, inputsState, dispatch) {
  return (0, _mapValues2.default)((0, _omit2.default)(inputConfig, _mountPoint.REDUX_MOUNT_POINT), function (config, id) {
    var inputState = inputsState[id];
    (0, _invariant.default)(inputState, "[redux-inputs]: ".concat(id, " not found in state. Make sure to configure your redux-input reducer."));
    var value = inputState.value,
        error = inputState.error,
        otherState = (0, _objectWithoutProperties2.default)(inputState, ["value", "error"]);
    var hasError = typeof error !== 'undefined';
    return (0, _objectSpread2.default)({
      _id: [(0, _mountPoint.getReduxMountPoint)(inputConfig), id].join('-'),
      value: hasError ? error : value,
      error: hasError,
      // Prebound change callback
      dispatchChange: function dispatchChange(newVal) {
        return dispatch((0, _actions.updateAndValidate)(inputConfig, (0, _defineProperty2.default)({}, id, newVal)));
      }
    }, config.props, otherState);
  });
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/util/getInputProps.js
// module id = 491
// module chunks = 0